import currency from 'currency.js';
import flatten from 'lodash/flatten';
import take from 'lodash/take';
import zip from 'lodash/zip';
import { Union } from 'ts-toolbelt';

export const formatDollar = (value: Union.Nullable<number>): string =>
  value != null ? currency(value, { symbol: '$', precision: 0 }).format() : '';

export const PHONE_FORMAT = '(999) 999-9999';
export const formatPhone = (value: Union.Nullable<string>): string => {
  const PATTERN = PHONE_FORMAT.split('9');
  const digits = take(value?.match(/\d/g) ?? [], 10);

  return flatten(zip(take(PATTERN, digits.length), digits)).join('');
};
